import { useCallback, useReducer, useMemo } from 'react'
import * as R from 'ramda'

export function usePagination(defaultValue) {
  const initialState = useMemo(() => R.mergeLeft(
    defaultValue,
    {
      current: 1,
      pageSize: 10,
      total: 0,
      hideOnSinglePage: true,
    },
  ), [defaultValue])

  const reducer = useCallback((state, action) => {
    switch (action.type) {
      case 'update':
        return R.mergeLeft(action.payload, state)
      case 'reset':
        return initialState
      default:
        throw new Error('unknow action')
    }
  }, [defaultValue])

  const [state, dispatch] = useReducer(reducer, initialState)

  return [state, dispatch]
}
